import { ButtonComponent, ModalComponent } from "@/components";
import { Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import Image from "next/image";

const FaceVerificationModal = ({ open, handleModal, closeModal, data }) => {
  const t = useTranslations("faceverification");
  const { icon, label, subLabel, buttonLabel } = data ?? {};

  return (
    <ModalComponent open={open} handleModal={closeModal}>
      <Stack justifyContent={"center"} spacing={2} width={"100%"}>
        <Stack justifyContent={"center"} alignItems={"center"}>
          <Image src={icon} alt="Face not verified" />
        </Stack>
        <Typography align="center">{label}</Typography>
        {subLabel &&
          (typeof subLabel === "string" ? (
            <Typography align="center" component={"div"}>
              {subLabel}
            </Typography>
          ) : (
            subLabel
          ))}
        {/* <Typography align="center">{data?.subLabel}</Typography> */}
        <ButtonComponent
          buttonStyle={{ width: "100%", minWidth: "40%" }}
          toolTipTitle={t("modalttoltip")}
          onClick={() => {
            handleModal(false);
          }}
        >
          {buttonLabel}
        </ButtonComponent>
      </Stack>
    </ModalComponent>
  );
};

export default FaceVerificationModal;
